import { Cached, ServiceAuthType } from '@uploadcam/common';
import { environment } from '../../environments/environment';
import { LoginWithPopupGenericAdapterInteractor } from '../auth/domain/interactors/login-with-popup-generic-adapter.interactor';
import { RefreshCredentialAdapterInteractor } from '../auth/domain/interactors/refresh-credential.interactor';
import { CommonProvider } from '../common/common.provider';
import { ExchangeDropboxAuthCodeInteractor } from './domain/exchange-dropbox-auth-code.interactor';
import { GetDropboxAuthUrlInteractor } from './domain/get-dropbox-auth-url.interactor';
import { RefreshDropboxCredentialInteractor } from './domain/refresh-dropbox-credential.interactor';
import { LoginWithRedirectAdapterInteractor } from '../auth/domain/interactors/login-with-redirect.interactor';
import { ExchangeAuthCodeInteractor } from '../auth/domain/interactors/exchange-auth-code.interactor';
import { LoginWithRedirectGenericAdapterInteractor } from '../auth/domain/interactors/login-with-redirect-generic-adapter.interactor';
import { LoginWithPopupAdapterInteractor } from '../auth/domain/interactors/login-with-popup-adapter.interactor';

export abstract class AuthDropboxProvider {
  abstract provideExchangeDropboxAuthCode(): ExchangeAuthCodeInteractor;
  abstract provideLoginWithPopupDropboxAdapter(): LoginWithPopupAdapterInteractor;
  abstract provideLoginWithRedirectDropboxAdapter(): LoginWithRedirectAdapterInteractor;
  abstract provideRefreshDropboxCredential(): RefreshCredentialAdapterInteractor;
  abstract provideRequiredScopes(): readonly string[];
}

export class AuthDropboxDefaultProvider implements AuthDropboxProvider {
  private getDropboxAuthUrlInteractor = new GetDropboxAuthUrlInteractor(
    environment.dropbox.clientId,
    this.common.provideOAuthRedirectUri(ServiceAuthType.Dropbox),
  );

  constructor(
    private readonly common: CommonProvider,
    private readonly window: Window,
  ) {}

  @Cached()
  public provideExchangeDropboxAuthCode(): ExchangeAuthCodeInteractor {
    return new ExchangeDropboxAuthCodeInteractor(
      environment.dropbox.clientId,
      this.common.provideOAuthRedirectUri(ServiceAuthType.Dropbox),
    );
  }

  @Cached()
  public provideLoginWithPopupDropboxAdapter(): LoginWithPopupAdapterInteractor {
    return new LoginWithPopupGenericAdapterInteractor(
      this.getDropboxAuthUrlInteractor,
      this.common.provideLogger().withTag('LoginWithPopupInteractor<Dropbox>'),
      environment.auth.popup.timeout,
      this.window,
      'Dropbox Login',
    );
  }

  @Cached()
  public provideLoginWithRedirectDropboxAdapter(): LoginWithRedirectAdapterInteractor {
    return new LoginWithRedirectGenericAdapterInteractor(this.getDropboxAuthUrlInteractor);
  }

  @Cached()
  public provideRefreshDropboxCredential(): RefreshDropboxCredentialInteractor {
    return new RefreshDropboxCredentialInteractor(environment.dropbox.clientId);
  }

  public provideRequiredScopes(): readonly string[] {
    return [];
  }
}
